import { Icons } from '../Icons';

export const StepperItemIcon = ({
  isCompleted,
  disabled,
  isActive,
}: {
  isCompleted: boolean;
  disabled: boolean;
  isActive: boolean;
}) => {
  if (isCompleted)
    return (
      <div className="flex justify-center items-center size-5 rounded-full bg-fg-success group-hover:bg-fg-success-hover transition-colors shrink-0">
        <Icons.Check className="size-3 text-fg-white" />
      </div>
    );

  if (disabled)
    return (
      <div className="size-5 flex justify-center items-center shrink-0">
        <div className="size-2.5 rounded-full bg-fg-disabled" />
      </div>
    );

  if (isActive) {
    return (
      <div className="size-5 rounded-full bg-fg-secondary group-hover:bg-fg-secondary-hover flex justify-center items-center transition-colors shrink-0">
        <div className="size-1.5 bg-white rounded-full" />
      </div>
    );
  }

  return (
    <div className="size-5 rounded-full bg-bg-disabled-subtle border border-border-primary-hover group-hover:bg-bg-disabled group-hover:border-fg-quinary-hover transition-colors shrink-0" />
  );
};
